module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/common/loader/loader.component.css
// module id = ./src/app/common/loader/loader.component.css
// module chunks = main